export const ACCOUNT_API_TRANSLOCO_SCOPE = 'account';
